import { simulateOfflineMap } from '#nora-ui/global/simulate-offline-map';
import { simulateAccuracyImprovement, simulateHeadingChange, simulatePosition } from '#nora-ui/global/simulate-position';

declare global {
  interface Window {
    simulatePosition: () => Promise<void>;
    simulateAccuracyImprovement: () => Promise<void>;
    simulateHeadingChange: () => Promise<void>;
    simulateOfflineMap: (url: string, name?: string) => void;
  }
}

export function registerGlobalFunctions() {
  window.simulatePosition = simulatePosition;
  window.simulateAccuracyImprovement = simulateAccuracyImprovement;
  window.simulateHeadingChange = simulateHeadingChange;
  window.simulateOfflineMap = simulateOfflineMap;
}
